import { useState, useEffect } from "react";
import axios from "axios";
import { useDropzone } from "react-dropzone"; // react-dropzoneをインポート
import s from './TourCreate.module.scss';
import { useNavigate } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDwvU6jPInYlh3hJGuOqsB-1qEJi1NYmDw",
  authDomain: "maa-admin-1d479.firebaseapp.com",
  projectId: "maa-admin-1d479",
  storageBucket: "maa-admin-1d479.firebasestorage.app",
  messagingSenderId: "1035947988500",
  appId: "1:1035947988500:web:f493632599949384e5f901",
  measurementId: "G-R58CPKGQBQ"
};

const firebaseApp = initializeApp(firebaseConfig);
const storage = getStorage(firebaseApp);

const Label = ({ htmlFor, children, required }: { htmlFor: string; children: string; required?: boolean }) => (
  <label htmlFor={htmlFor} className={s.label}>
    {children}
    {required && <span className={s.required}>※</span>}
  </label>
);

const TourCreate = () => {
  const navigate = useNavigate();
  const [tour, setTour] = useState({
    title: "",
    regular_price: "",
    sale_price: "",
    rezdy_id: "",
    tour_code: "",
    is_sale: false,
    is_hidden: false,
    popularity: "",
    details: "",
  });
  const [categories, setCategories] = useState([]);
  const [tags, setTags] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState(null);
  const [tourId, setTourId] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchCategoriesAndTags = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/admin/categories-and-tags`);
        const { categories, tags } = response.data;
        setCategories(categories);
        setTags(tags);
      } catch (err) {
        setError('カテゴリーまたはタグの取得に失敗しました');
        console.error("Failed to fetch categories or tags:", err);
      }
    };

    fetchCategoriesAndTags();
  }, [apiUrl]);

  const toggleCategorySelection = (categoryId) => {
    setSelectedCategories((prevSelected) => {
      if (prevSelected.includes(categoryId)) {
        return prevSelected.filter(id => id !== categoryId);
      }
      return [...prevSelected, categoryId];
    });
  };

  const toggleTagSelection = (tagId) => {
    setSelectedTags((prevSelected) => {
      if (prevSelected.includes(tagId)) {
        return prevSelected.filter(id => id !== tagId);
      }
      return [...prevSelected, tagId];
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    console.log('checked', checked)
    console.log('name', name)
    console.log('type', type)
    console.log('tour', tour)

    const halfWidthFields = ["tour_code", "rezdy_id"];

    setTour((prevTour) => ({
      ...prevTour,
      [name]: type === "checkbox"
        ? checked
        : halfWidthFields.includes(name)
        ? value.replace(/[^\x20-\x7E]/g, "")
        : value,
    }));
  };

  const handleDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      setImage(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setImage(file);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
      }
    },
    accept: 'image/*',
  });


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!image) {
      setError("画像を選択してください");
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const storageRef = ref(storage, `images/${image.name}`);
      const snapshot = await uploadBytes(storageRef, image);
      console.log("アップロードに成功しました", snapshot);

      const imageUrl = await getDownloadURL(storageRef);
      console.log("画像URL:", imageUrl);

      const formData = new FormData();
      formData.append('title', tour.title);
      formData.append('details', tour.details);
      formData.append('regular_price', tour.regular_price);
      formData.append('sale_price', tour.sale_price);
      formData.append('tour_code', tour.tour_code);
      formData.append('rezdy_id', tour.rezdy_id);
      formData.append('is_sale', tour.is_sale ? 1 : 0);
      formData.append('is_hidden', tour.is_hidden ? 1 : 0);
      formData.append('image', imageUrl);

      if (tour.popularity !== null && tour.popularity !== undefined) {
        formData.append('popularity', tour.popularity);
      }

      selectedCategories.forEach((category) => {
        formData.append('categories[]', category);
      });
      selectedTags.forEach((tag) => {
        formData.append('tags[]', tag);
      });

      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }

      const response = await axios.post(`${apiUrl}/api/admin/create-tour`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 201) {
        setSuccessMessage(response.data.message)
        setTimeout(() => setSuccessMessage(""), 3000);
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTourId(response.data.tour.id);
      } else {
        setError("ツアーの作成に失敗しました");
      }
    } catch (error) {
      setError(error.response?.data?.message);
      if (error.response && error.response.status === 422) {
        console.log(error.response.data.errors);
      }
    } finally {
      setLoading(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!image) {
  //     setError("画像を選択してください");
  //     return;
  //   }
  //   setLoading(true);
  //   setError(null);


  //   const formData = new FormData();
  //   formData.append('title', tour.title);
  //   formData.append('regular_price', tour.regular_price);
  //   formData.append('sale_price', tour.sale_price);
  //   formData.append('tour_code', tour.tour_code);
  //   formData.append('rezdy_id', tour.rezdy_id);
  //   formData.append('is_sale', tour.is_sale ? 1 : 0);
  //   formData.append('image', image);
  //   selectedCategories.forEach(category => {
  //     formData.append('categories[]', category);
  //   });

  //   selectedTags.forEach(tag => {
  //       formData.append('tags[]', tag);
  //   });
  //   for (let [key, value] of formData.entries()) {
  //     console.log(`${key}: ${value}`);
  // }

  // try {
  //   const response = await axios.post(`${apiUrl}/api/admin/create-tour`, formData, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //   });

  //   if (response.status === 201) {
  //     }
  //   } catch (error) {
  //     setError("ツアー作成に失敗しました");
  //     if (error.response && error.response.status === 422) {
  //       console.log(error.response.data.errors);
  //     }

  //   } finally {
  //     setLoading(false);
  //   }
  // };


  return (
    <div className={s.root}>
      <button onClick={() => navigate("/")} className={s.backButton}>
        ホームに戻る
      </button>
      <button
        onClick={() => navigate(`/create-tour-details/${tourId}`)}
        className={s.planButton}
      >
        プラン詳細を作成
      </button>
      <h2>新しいツアーを作成</h2>
      <form onSubmit={handleSubmit}>
        {error && <div className={s.error}>{error}</div>}
        {successMessage && <div className={s.success}>{successMessage}</div>}
        <div className={s.formGroupContainer}>
          <div className={s.formGroup}>
            <Label htmlFor="title" required>
              タイトル
            </Label>
            <input
              type="text"
              id="title"
              name="title"
              value={tour.title}
              onChange={handleChange}
              required
              className={s.titleInput}
            />
          </div>

          <div className={s.formGroup}>
            <Label htmlFor="regular_price" required>
              標準価格
            </Label>
            <input
              type="number"
              id="regular_price"
              name="regular_price"
              value={tour.regular_price}
              onChange={handleChange}
              required
            />
          </div>

          <div className={s.formGroup}>
            <Label htmlFor="sale_price" required>
              セール価格
            </Label>
            <input
              type="number"
              id="sale_price"
              name="sale_price"
              value={tour.sale_price}
              onChange={handleChange}
            />
          </div>

          <div className={s.formGroup}>
            <Label htmlFor="tour_code" required>
              ツアーコード
            </Label>
            <input
              type="text"
              id="tour_code"
              name="tour_code"
              value={tour.tour_code}
              onChange={handleChange}
              required
            />
          </div>

          <div className={s.formGroup}>
            <Label htmlFor="rezdy_id" required>
              Rezdy ID
            </Label>
            <input
              type="text"
              id="rezdy_id"
              name="rezdy_id"
              value={tour.rezdy_id}
              onChange={handleChange}
              required
            />
          </div>
          <div className={s.formGroup}>
            <Label htmlFor="popularity">
              順番
            </Label>
            <input
              type="number"
              id="popularity"
              name="popularity"
              value={tour.popularity}
              onChange={handleChange}
            />
          </div>
          <div className={s.checkboxGroup}>
            <label htmlFor="is_sale">セール中</label>
            <input
              type="checkbox"
              id="is_sale"
              name="is_sale"
              checked={tour.is_sale}
              onChange={handleChange}
            />
          </div>
          <div className={s.checkboxGroup}>
            <label htmlFor="is_hidden">非公開</label>
            <input
              type="checkbox"
              id="is_hidden"
              name="is_hidden"
              checked={tour.is_hidden}
              onChange={handleChange}
            />
          </div>
          <div className={s.formGroup}>
            <Label htmlFor="details">
              meta:description
            </Label>
            <input
              type="text"
              id="details"
              name="details"
              value={tour.details}
              onChange={handleChange}
              className={s.titleInput}
            />
          </div>
          <div>
            <h3>カテゴリーを選択</h3>
            <div className={s.selectionContainer}>
              {categories.map((category) => (
                <div
                  key={category.id}
                  className={`${s.selectionItem} ${selectedCategories.includes(category.id) ? s.selected : ''}`}
                  onClick={() => toggleCategorySelection(category.id)}
                >
                  {category.name}
                </div>
              ))}
            </div>

            <h3>タグを選択</h3>
            <div className={s.selectionContainer}>
              {tags.map((tag) => (
                <div
                  key={tag.id}
                  className={`${s.selectionItem} ${selectedTags.includes(tag.id) ? s.selected : ''}`}
                  onClick={() => toggleTagSelection(tag.id)}
                >
                  ♯ {tag.name}
                </div>
              ))}
            </div>

            <h3>サムネイル</h3>
            <div {...getRootProps()} className={s.dropzone}>
              {previewUrl ? (
                <img src={previewUrl} alt="プレビュー" />
              ) : (
                <p>画像を選択</p>
              )}
              <input {...getInputProps()} />
            </div>
          </div>
        </div>

        <button type="submit" className={s.saveButton} disabled={loading}>
          {loading ? "作成中..." : "作成"}
        </button>
      </form>
    </div>
  );
};

export default TourCreate;
